import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Util } from '../utils/util';
import { RequiredFieldsModel } from '../models/required-fields.model';

@Injectable()
export class FilterFormValidatorService {

    /**
     * Valida os campos do formgroup enviado, e retorna um booleano de acordo com o arquivo de configuração enviado.
     * @param form FormGroup que deseja validar.
     * @param config Arquivo de configuração do modelo RequiredFieldsModel.
     */
    public Validate(form: FormGroup, config: RequiredFieldsModel): boolean {

        if (form.controls && ((config.requiredFields && config.requiredFields.length > 0) || (config.groupFields && config.groupFields.length > 0))) {

            // Caso tenha sido informado algum campo liberatory
            if (config.liberatoryFields && config.liberatoryFields.length > 0) {
                if (this.IterateLiberatoryFields(form, config)) {
                    return true;
                }
            }

            // Caso tenha sido informado algum campo group
            if (config.groupFields && config.groupFields.length > 1) {

                let totalValidGroupFields = 0;

                config.groupFields.forEach(field => {
                    if (this.ValidateField(form, field)) {
                        totalValidGroupFields++;
                    }
                });

                if ((totalValidGroupFields === config.groupFields.length) && this.ValidateDateFields(form)) {
                    return true;
                }
            }

            // Caso tenha apenas obrigatórios
            if (config.requiredFields && config.requiredFields.length > 0) {

                if (this.IterateRequiredFields(form, config)) {
                    return true;
                }
            }

            return false;
        } else {
            return false;
        }
    }

    /**
     * Itera em campos do tipo Liberatory.
     * @param form FormGroup que deseja iterar.
     * @param config config com os nomes dos campos.
     */
    private IterateLiberatoryFields(form: FormGroup, config: RequiredFieldsModel): boolean {
        return this.IterateStringArray(form, config.liberatoryFields);
    }

    /**
    * Itera em campos do tipo Required.
    * @param form FormGroup que deseja iterar.
    * @param config config com os nomes dos campos.
    */
    private IterateRequiredFields(form: FormGroup, config: RequiredFieldsModel): boolean {
        return this.IterateStringArray(form, config.requiredFields);
    }

    /**
     * Itera em uma lista de campos de um formgroup.
     * @param form FormGroup que deseja iterar.
     * @param array array de strings com os nomes dos campos.
     */
    private IterateStringArray(form: FormGroup, array: string[]): boolean {

        let valid = false;

        array.forEach(field => {
            if (this.ValidateField(form, field)) {
                valid = true;
                return valid;
            }
        });

        return valid;
    }

    /**
     * Verifica se o campo existe no form e se possui um valor válido.
     * @param form FormGroup que deseja validar.
     * @param field String com o nome do campo que pertence ao formGroup.
     */
    private ValidateField(form: FormGroup, field: string): boolean {
        const control = form.get(field);

        if (control) {
            if (control.value instanceof Date) {
                return Util.dateIsValid(control.value);
            } else {
                return (control.value && control.value !== -1);
            }
        }

        return false;
    }

    /**
     * Verifica se as datas são validas e se estão dentro dos 45 dias.
     * @param form FormGroup que deseja validar.
     */
    private ValidateDateFields(form: FormGroup): boolean {

        const dtInicio = form.get('DtInicio');
        const dtFim = form.get('DtFim');

        // Flags de validação
        let dataInicioFoiDefinida = false;
        let dataFimFoiDefinida = false;
        let dataInicioValida = false;
        let dataFimValida = false;
        let diferencasEntreDatasValida = true;
        // ***********************************

        dataInicioFoiDefinida = dtInicio != null;
        dataFimFoiDefinida = dtFim != null;

        // Validação da data fim
        if (dataFimFoiDefinida) {
            dataFimValida = Util.dateIsValid(dtFim.value)
        }
        else {
            dataFimValida = true;
        }
        // **********************

        // Validação da data inicio
        if (dataInicioFoiDefinida) {
            dataInicioValida = Util.dateIsValid(dtInicio.value)
        }
        else {
            dataInicioValida = true;
        }
        // ************************

        let datasNaoInformadas = (!dataInicioFoiDefinida && !dataFimFoiDefinida);
        if (datasNaoInformadas) {
            return true;
        }
        else {
            if (dataInicioFoiDefinida && dataFimFoiDefinida) {
                diferencasEntreDatasValida = Util.getMaxIntervalFilterDays() >= Util.diffData(dtInicio.value, dtFim.value);
            }
        }
        return datasNaoInformadas || (dataInicioValida && dataFimValida && diferencasEntreDatasValida);
    }
}
